import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-311">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full items-center justify-between py-6 text-left focus:outline-none group" aria-expanded={isOpen} data-id="element-312">
        <span className="text-lg font-medium text-text-primary font-serif group-hover:text-accent transition-colors duration-300" data-id="element-313">
          {question}
        </span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="ml-4 flex-shrink-0 text-text-muted group-hover:text-accent" data-id="element-314">
          <ChevronDown className="h-5 w-5" data-id="element-315" />
        </motion.span>
      </button>
      <AnimatePresence data-id="element-316">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-317">
            <div className="pb-6 text-text-muted leading-relaxed" data-id="element-318">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}